<template>
  <div class="product__hero">
    <img :src="src" alt="Hero" />
  </div>
</template>

<script setup>
defineProps({ src: String })
</script>

<style lang="scss" scoped>
.product__hero {
  position: absolute;
  bottom: 0;
  right: 0;
  border: 2px solid white;
  border-radius: 100%;
  width: 48px;
  height: 48px;
  flex-shrink: 0;
  transform: translateX(25%) translateY(25%);

  img {
    width: 100%;
    height: 100%;
    border-radius: 50%;
  }
}
</style>
